import sha1 from 'js-sha1';
import dayjs from '~/timeInit';

import constants from './latitudeConstants';

const timeInMilliseconds = dayjs().valueOf();
const sha1WithHmac = sha1 as typeof sha1 & {
  hmac: (key: string, message: string) => string;
};

export function generateRequest(map, publicKey) {
  const generatedMap = {
    ...map,
    [constants.PAGE_TIMESTAMP]: timeInMilliseconds,
  };
  return insertSignature(generatedMap, publicKey);
}

function insertSignature(inputObject, publicKey) {
  const customFields = Object.keys(inputObject).join(',');
  let dataToSign = Object.keys(inputObject)
    .map((key) => `${key}=${inputObject[key]}`)
    .join(',');

  dataToSign += `,${constants.SIGNED_FIELDS_PUBLIC_SIGNATURE}=${getPublicDigest(customFields, publicKey)}`;

  return {
    ...inputObject,
    [constants.PAGE_PUBLIC_SIGNATURE]: getPublicDigest(dataToSign, publicKey),
    [constants.PAGE_SIGNED_FIELDS]: customFields,
  };
}

function getPublicDigest(customValues, publicKey) {
  return hexToBase64(sha1WithHmac.hmac(publicKey, customValues));
}

function hexToBase64(hex) {
  const bytes = hex.match(/.{1,2}/g).map((byte) => String.fromCharCode(parseInt(byte, 16)));
  return btoa(bytes.join(''));
}
